import {SagaIterator} from 'redux-saga';

import {call, select} from 'redux-saga/effects';

import {LOCAL_STORAGE_CHECKOUT, LOCAL_STORAGE_ORDER_DATA} from 'constants/analytics';
import {apiConfig} from 'libs/api/api';
import {localStore} from 'libs/storage/storage';

import {getEntireCheckout as getEntireCheckoutSideReview} from '../../selectors/completeOrder/completeOrder';

/**
 * Save checkout side-review data to session storage.
 *
 * @param additionalFields - additional fields.
 */
export function* saveCheckoutSideReviewData(additionalFields = {}): SagaIterator {
    const {
        orderReviewTotals: {discount = {}, subtotal = 0} = {},
        paymentStep: {selectedMethod},
    } = yield select(getEntireCheckoutSideReview);

    yield call(
        [localStore, 'set'],
        LOCAL_STORAGE_CHECKOUT,
        JSON.stringify({
            paymentMethod: selectedMethod,
            review: {
                discount: discount.price || 0,
                subTotal: subtotal,
            },
            ...additionalFields,
        }),
    );
}

/**
 * Save cart data to session storage.
 */
export function* saveCartData(): SagaIterator {
    const {cart} = apiConfig.hostStore.getState();
    yield call([localStore, 'set'], LOCAL_STORAGE_ORDER_DATA, JSON.stringify(cart));
}

/**
 * Return user email from localStorage
 * @return {string} - user email or empty string
 */
export function* getUserEmailFromStorage(): SagaIterator {
    const userEmail = yield call([localStore, 'get'], 'email', '');

    return userEmail || '';
}

/**
 * Save order details to session storage.
 */
export function* saveOrderDetails(): SagaIterator {
    yield call(saveCartData);
    yield call(saveCheckoutSideReviewData);
}
